// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'

import { auth } from '@/firebase' // Firebase
import CoreComponents from '@/components' // Components
import CoreFragments from '@/fragments' // Components
import moment from 'vue-moment' // Time
import Snotify, { SnotifyPosition } from 'vue-snotify' // Better Toast
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import DateRangePicker from '@gravitano/vue-date-range-picker'

Vue.config.productionTip = false

Vue.use(DateRangePicker)
Vue.use(BootstrapVue)
Vue.use(CoreComponents)
Vue.use(CoreFragments)
Vue.use(moment)
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop,
  },
})

let app

auth.onAuthStateChanged(function(user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: {
        App,
        ChartJsPluginDataLabels,
      },
      data: {
      },
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js